import { render } from "./DocuSignModal.vue?vue&type=template&id=83c45586&scoped=true&ts=true"
import script from "./DocuSignModal.vue?vue&type=script&lang=ts"
export * from "./DocuSignModal.vue?vue&type=script&lang=ts"

import "./DocuSignModal.vue?vue&type=style&index=0&id=83c45586&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c45586"]])

export default __exports__